﻿import type { IQueryParams } from '../types/utils/html-query-url';

function changeUrlIfMerged(modelId: number) {
    let path = location.pathname;
    const splitted = path.split('/');
    const id = parseInt(splitted.pop() ?? '');
    if (id !== modelId) {
        splitted.push(modelId.toString());
        path = splitted.join('/');
        const newUrl = location.protocol + '//' + location.host + path;
        window.history.pushState({ path: newUrl }, '', newUrl);
    }
}

function currentPageData() {
    const splitted = location.pathname.split('/').filter(String).reverse();
    const data = {
        entityPage: splitted[1],
        entityId: splitted[0]
    };
    if (data.entityId.toLocaleLowerCase().includes('favorite')) {
        data.entityPage = data.entityId;
        data.entityId = '0';
    }
    return data;
}

function getQueryParams(): IQueryParams {
    const regex = /IsFilter.+/g;
    const query = window.location.search.substring(1);
    const newQuery = query.search(regex) !== -1 ? (query.match(regex)?.[0] ?? '') : query;

    let params = newQuery.split('&');
    let result: IQueryParams = {};

    if (params.length > 1 && params[0] === 'IsFilter=0') {
        params.shift();
        const decodedParams = getDecodedQueryParam(params[0]);
        if (decodedParams.length > 0)
            params = decodedParams;

        result = extractKeyValuePairs(params);
    }

    return result;
}

function applyFiltersIfParamsExist(...grids: (kendo.ui.Grid | kendo.ui.TreeList)[]) {
    if (Object.keys(getQueryParams()).length) {
        grids.forEach(grid => window.setFilters(grid, false));
    }
}

function getSettings(): GridSettingsInUrl | null {
    const paramDictionary = getQueryParams();
    const json = paramDictionary['settings'];

    if (json) {
        const jsonReplace = json.replaceAll(/%22/g, '"').replaceAll(/%7B/g, '{').replaceAll(/%7D/g, '}');
        return JSON.parse(jsonReplace.toString());
    }

    return null;
}

function getPageGrid() {
    const paramDictionary = getQueryParams();
    const json = paramDictionary['settings'];

    if (json) {
        const page = json.replaceAll(/%22/g, '"').match(/\d+/g)?.[0];
        if (page) return parseInt(page);
    }

    return 1;
}

function getDecodedQueryParam(encodedParam: string): string[] {
    const base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
    let decodedParams: string[] = [];

    if (base64Regex.test(encodedParam)) {
        const originQuery = window.decompressFromBase64(encodedParam);
        decodedParams = originQuery.split('&');
    }

    return decodedParams;
}

function extractKeyValuePairs(vars: string[]): IQueryParams {
    const result: IQueryParams = {};
    vars.forEach((param: string) => {
        const pair = param.split('=');
        if (pair.length === 2 && pair[1] !== '')
            result[pair[0]] = pair[1];
    });

    return result;
}

function getId() {
    const param = getQueryParams()['Id'];
    if (param) return parseInt(param);
    return undefined;
}

window.changeUrlIfMerged = changeUrlIfMerged;
window.currentPageData = currentPageData;
window.getQueryParams = getQueryParams;
window.applyFiltersIfParamsExist = applyFiltersIfParamsExist;
window.getSettings = getSettings;
window.getPageGrid = getPageGrid;
window.getDecodedQueryParam = getDecodedQueryParam;
window.extractKeyValuePairs = extractKeyValuePairs;
window.getId = getId;